import { render, staticRenderFns } from "./FormPendingModal.vue?vue&type=template&id=5e9945f0"
import script from "./FormPendingModal.vue?vue&type=script&lang=js"
export * from "./FormPendingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports